import { TestimonialDto } from "../components/blocks/marketing/testimonials/TestimonialsBlockUtils";

export const defaultTestimonials: TestimonialDto[] = [
  {
    role: "Owner",
    company: "Harvest Home Goods",
    name: "Mara J.",
    personalWebsite: "",
    avatar: "",
    title: "A lifesaver for monitoring vendor bills and price changes",
    quote:
      "Before Lunova, I was manually checking vendor bills and hoping nothing slipped through. Now, I get alerts when costs jump or pricing changes — it's saved us from multiple overcharges already. It's like having a financial assistant who never sleeps.",
    quoteUrl: "",
    createdAt: new Date("2025-02-14T09:25:00"),
    stars: 5,
  },
  {
    role: "COO",
    company: "Peak Athletic Supply",
    name: "James L.",
    personalWebsite: "",
    avatar: "",
    title: "Keeps our team proactive, not reactive",
    quote:
      "Lunova helps us stay ahead of our numbers. Our sales team gets notified when inventory arrives or when pricing changes. We’re shipping faster and quoting more accurately — and I don’t need to chase down reports anymore.",
    quoteUrl: "",
    createdAt: new Date("2025-02-28T16:40:00"),
    stars: 5,
  },
  {
    role: "Founder & CFO",
    company: "Modern Brew Co.",
    name: "Sarah P.",
    personalWebsite: "",
    avatar: "",
    title: "Exactly what QuickBooks was missing",
    quote:
      "I always wished QuickBooks had better alerting — Lunova nails it. We track deposits across multiple merchant accounts and instantly get notified. It’s become part of our daily workflow, and I genuinely don’t know how we managed without it.",
    quoteUrl: "",
    createdAt: new Date("2025-03-10T13:05:00"),
    stars: 5,
  },
  {
    role: "Operations Manager",
    company: "Evergreen Landscaping",
    name: "Luis M.",
    personalWebsite: "",
    avatar: "",
    title: "No more spreadsheets for deposit tracking",
    quote:
      "We used to rely on spreadsheets to track if payments landed. Lunova now gives us instant alerts on merchant deposits — no more guessing or backtracking. It's been a huge time-saver for our lean ops team.",
    quoteUrl: "",
    createdAt: new Date("2025-03-22T11:50:00"),
    stars: 5,
  },
  {
    role: "Bookkeeper",
    company: "Shoreline Design Studio",
    name: "Tina R.",
    personalWebsite: "",
    avatar: "",
    title: "Alerts tailored to *exactly* what we need",
    quote:
      "I set up custom alerts for high-value bills, overdue invoices, and deposit patterns. It's granular, easy to use, and helps me stay on top of my clients' books without constant digging through reports.",
    quoteUrl: "",
    createdAt: new Date("2025-04-09T08:10:00"),
    stars: 5,
  }
];
